import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  healthCategoryAll: [],
  healthCategory: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "categoryName",
  sortOrder: "asc",
};

const healthCategorySlice = createSlice({
  name: "healthCategory",
  initialState,
  reducers: {
    setHealthCategoryAll: (state, action) => {
      state.healthCategoryAll = action.payload;
    },
    setHealthCategory: (state, action) => {
      state.healthCategory = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setHealthCategoryAll,
  setHealthCategory,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = healthCategorySlice.actions;

export default healthCategorySlice.reducer;